export default __webpack_public_path__ + "015da20c228810137671fe953e5f4066.svg";